"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = exports.TherapistLandingWrap = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.TherapistLandingWrap = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding-bottom: 12px;

  * {
    margin: 0;
    box-sizing: border-box;
  }

  h1 {
    margin-bottom: 13px;
  }

  .landing-therapist-main-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  .landing-therapist-row {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 12px;
  }

  @media screen and (min-width: 768px) {
    gap: 12px;
    padding-bottom: 37px;

    h1 {
      margin: 0;
    }
    .landing-therapist-main-content {
      gap: 12px;
    }
  }

  @media screen and (min-width: 1000px) {
    padding-bottom: 53px;

    .landing-therapist-row {
      flex-direction: row;
    }
  }

  @media screen and (min-width: 1300px) {
    gap: 27px;
    padding-bottom: 40px;
  }

  @media screen and (min-width: 1690px) {
    gap: 19px;
    padding-bottom: 50px;
  }

  @media screen and (min-width: 1920px) {
    gap: 12px;
    padding-bottom: 60px;
  }
`;
exports.Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 12px;
  border-radius: 18px;
  background-color: white;
  width: fit-content;

  h2,
  h3 {
    font-family: Phenomena, sans-serif;
    font-size: 24px;
    font-weight: 700;
    line-height: 29px;
    text-align: left;
    color: #7b4ef8;
  }

  strong {
    font-family: Inter, sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 19px;
    text-align: left;
    color: #7b4ef8;
  }

  p {
    font-family: Inter, sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 19px;
    text-align: left;
  }

  button {
    cursor: pointer;
    border: none;
    background-color: #6e76fb;
    color: white;
    border-radius: 12px;
    padding: 12px 16px;
    font-family: Inter, sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 19px;
    text-align: left;
  }

  .landing-therapist-container-info {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    justify-content: center;
  }

  .landing-therapist-container-content {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    justify-content: center;
  }

  .landing-therapist-container-images {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;

    svg {
      width: 74px;
      height: auto;
    }
  }

  &.landing-therapist-oralo {
    img {
      height: 137px;
    }

    p {
      max-width: 288px;
    }
  }

  &.landing-therapist-settings {
    padding: 162px 12px 12px 12px;
    position: relative;
    align-items: flex-end;
    justify-content: flex-end;

    img {
      position: absolute;
      width: 154px;
      top: 3px;
      left: 50%;
      transform: translateX(-50%);
    }

    h2 {
      max-width: 243px;
    }
  }

  &.landing-therapist-1 {
    max-width: 280px;
  }

  &.landing-therapist-2 {
    max-width: 281px;

    button {
      max-width: 216px;
    }
  }

  &.landing-therapist-3 {
    max-width: 248px;
  }

  &.landing-therapist-4 {
    max-width: 260px;
  }

  &.landing-therapist-5 {
    max-width: 274px;
  }

  &.landing-therapist-6 {
    max-width: 288px;
  }

  @media screen and (min-width: 768px) {
    gap: 16px;
    padding: 24px;
    border-radius: 18px;
    flex-direction: row;

    h2 {
      font-size: 40px;
      line-height: 48px;
    }

    h3 {
      font-size: 24px;
      line-height: 29px;
    }

    strong {
      font-size: 24px;
      line-height: 29px;
    }

    p {
      font-size: 16px;
      line-height: 19px;
    }

    button {
      border-radius: 33px;
      padding: 12px 16px;
      font-size: 16px;
      font-weight: 600;
      line-height: 19px;
    }

    .landing-therapist-container-info {
      gap: 8px;
      align-items: flex-start;
    }

    .landing-therapist-container-content {
      gap: 12px;
      align-items: flex-start;
    }

    .landing-therapist-container-images {
      flex-direction: column;
      gap: 16px;

      svg {
        width: 74px;
        height: auto;
      }
    }

    &.landing-therapist-oralo {
      flex-direction: row;
      position: relative;
      width: 662px;
      height: 264px;
      justify-content: flex-end;
      margin: 53px 0 25px 0;

      img {
        position: absolute;
        width: 189px;
        top: 5px;
        left: -40px;
      }

      strong {
        display: inline;
      }

      p {
        max-width: 476px;
        font-size: 24px;
        line-height: 29px;
      }
    }

    &.landing-therapist-settings {
      padding: 16px 16px 16px 170px;
      position: relative;
      align-items: flex-end;
      justify-content: flex-end;

      img {
        position: absolute;
        width: 202px;
        top: -12px;
        left: -24px;
        transform: none;
      }

      h2 {
        max-width: 430px;
      }
    }

    &.landing-therapist-1 {
      max-width: 557px;
    }

    &.landing-therapist-2 {
      max-width: 538px;

      button {
        max-width: 309px;
      }
    }

    &.landing-therapist-3 {
      max-width: 431px;
    }

    &.landing-therapist-4 {
      max-width: 382px;
    }

    &.landing-therapist-5 {
      max-width: 579px;
    }

    &.landing-therapist-6 {
      max-width: 661px;
    }
  }

  @media screen and (min-width: 1000px) {
    gap: 16px;
    padding: 24px;
    border-radius: 18px;
    flex-direction: row;

    h2 {
      font-size: 40px;
      line-height: 48px;
    }

    h3 {
      font-size: 24px;
      line-height: 29px;
    }

    strong {
      font-size: 24px;
      line-height: 29px;
    }

    p {
      font-size: 16px;
      line-height: 19px;
    }

    button {
      border-radius: 33px;
      padding: 12px 16px;
      font-size: 16px;
      font-weight: 600;
      line-height: 19px;
    }

    .landing-therapist-container-info {
      gap: 8px;
      align-items: flex-start;
    }

    .landing-therapist-container-content {
      gap: 12px;
      align-items: flex-start;
    }

    .landing-therapist-container-images {
      flex-direction: column;
      gap: 16px;

      svg {
        width: 74px;
        height: auto;
      }
    }

    &.landing-therapist-oralo {
      flex-direction: row;
      position: relative;
      width: unset;
      height: unset;
      padding: 16px 16px 16px 172px;
      justify-content: flex-end;
      margin: 28px 0;

      img {
        position: absolute;
        width: 189px;
        top: 5px;
        left: -40px;
      }

      strong {
        display: inline;
      }

      p {
        max-width: 688px;
        font-size: 24px;
        line-height: 29px;
      }
    }

    &.landing-therapist-settings {
      padding: 16px 16px 16px 170px;
      position: relative;
      align-items: flex-end;
      justify-content: flex-end;

      img {
        position: absolute;
        width: 202px;
        top: -12px;
        left: -24px;
        transform: none;
      }

      h2 {
        max-width: 430px;
      }
    }

    &.landing-therapist-1 {
      max-width: 920px;
    }

    &.landing-therapist-2 {
      max-width: 538px;

      button {
        max-width: unset;
      }
    }

    &.landing-therapist-3 {
      max-width: 431px;
    }

    &.landing-therapist-4 {
      max-width: 382px;
    }

    &.landing-therapist-5 {
      max-width: 396px;
    }

    &.landing-therapist-6 {
      max-width: 448px;
    }
  }

  @media screen and (min-width: 1300px) {
    gap: 24px;
    padding: 24px;
    border-radius: 24px;
    flex-direction: row;

    h2 {
      font-size: 64px;
      line-height: 77px;
      text-align: left;
    }

    h3 {
      font-size: 27px;
      line-height: 33px;
    }

    strong {
      font-size: 24px;
      line-height: 29px;
    }

    p {
      font-size: 24px;
      line-height: 29px;
    }

    button {
      border-radius: 50px;
      padding: 20px 25px;
      font-size: 24px;
      font-weight: 600;
      line-height: 29px;
    }

    .landing-therapist-container-info {
      gap: 12px;
      align-items: flex-start;
    }

    .landing-therapist-container-content {
      gap: 18px;
      align-items: flex-start;
    }

    .landing-therapist-container-images {
      flex-direction: column;
      gap: 24px;

      svg {
        width: 110px;
        height: auto;
      }
    }

    &.landing-therapist-oralo {
      flex-direction: row;
      position: relative;
      width: unset;
      height: unset;
      padding: 45px 24px 45px 258px;
      justify-content: flex-end;
      margin: 13px 0;

      img {
        position: absolute;
        width: 258px;
        height: auto;
        top: 10px;
        left: -40px;
      }

      strong {
        display: inline;
        font-size: 27px;
        line-height: 33px;
      }

      p {
        max-width: 882px;
        font-size: 27px;
        line-height: 33px;
      }
    }

    &.landing-therapist-settings {
      padding: 24px 24px 24px 258px;
      position: relative;
      align-items: flex-end;
      justify-content: flex-end;

      img {
        position: absolute;
        width: 303px;
        top: -17px;
        left: -36px;
        transform: none;
      }

      h2 {
        max-width: 645px;
      }
    }

    &.landing-therapist-1 {
      max-width: 1220px;
    }

    &.landing-therapist-2 {
      max-width: 848px;

      button {
        max-width: unset;
      }
    }

    &.landing-therapist-3 {
      max-width: 626px;
    }

    &.landing-therapist-4 {
      max-width: 571px;
    }

    &.landing-therapist-5 {
      max-width: 559px;
    }

    &.landing-therapist-6 {
      max-width: 648px;
    }
  }

  @media screen and (min-width: 1690px) {
    gap: 24px;
    padding: 24px;
    border-radius: 24px;
    flex-direction: row;

    h2 {
      font-size: 64px;
      line-height: 77px;
      text-align: left;
    }

    h3 {
      font-size: 27px;
      line-height: 33px;
    }

    strong {
      font-size: 24px;
      line-height: 29px;
    }

    p {
      font-size: 24px;
      line-height: 29px;
    }

    button {
      border-radius: 50px;
      padding: 20px 25px;
      font-size: 24px;
      font-weight: 600;
      line-height: 29px;
    }

    .landing-therapist-container-info {
      gap: 12px;
      align-items: flex-start;
    }

    .landing-therapist-container-content {
      gap: 18px;
      align-items: flex-start;
    }

    .landing-therapist-container-images {
      flex-direction: column;
      gap: 24px;

      svg {
        width: 110px;
        height: auto;
      }
    }

    &.landing-therapist-oralo {
      flex-direction: row;
      position: relative;
      width: unset;
      height: unset;
      padding: 61px 24px 61px 258px;
      justify-content: flex-end;
      margin: 31px 0;

      img {
        position: absolute;
        width: 258px;
        height: auto;
        top: 10px;
        left: -40px;
      }

      strong {
        display: inline;
        font-size: 27px;
        line-height: 33px;
      }

      p {
        max-width: 1062px;
        font-size: 27px;
        line-height: 33px;
      }
    }

    &.landing-therapist-settings {
      padding: 24px 24px 24px 258px;
      position: relative;
      align-items: flex-end;
      justify-content: flex-end;

      img {
        position: absolute;
        width: 303px;
        top: -17px;
        left: -36px;
        transform: none;
      }

      h2 {
        max-width: 645px;
      }
    }

    &.landing-therapist-1 {
      max-width: 1354px;
      font-size: 27px;
      line-height: 33px;
    }

    &.landing-therapist-2 {
      max-width: 848px;

      button {
        max-width: unset;
      }
    }

    &.landing-therapist-3 {
      max-width: 707px;
    }

    &.landing-therapist-4 {
      max-width: 571px;
    }

    &.landing-therapist-5 {
      max-width: 647px;
    }

    &.landing-therapist-6 {
      max-width: 677px;
    }
  }

  @media screen and (min-width: 1920px) {
    gap: 24px;
    padding: 24px;
    border-radius: 24px;
    flex-direction: row;

    h2 {
      font-size: 64px;
      line-height: 77px;
      text-align: left;
    }

    h3 {
      font-size: 27px;
      line-height: 33px;
    }

    strong {
      font-size: 24px;
      line-height: 29px;
    }

    p {
      font-size: 24px;
      line-height: 29px;
    }

    button {
      border-radius: 50px;
      padding: 20px 25px;
      font-size: 24px;
      font-weight: 600;
      line-height: 29px;
    }

    .landing-therapist-container-info {
      gap: 12px;
      align-items: flex-start;
    }

    .landing-therapist-container-content {
      gap: 18px;
      align-items: flex-start;
    }

    .landing-therapist-container-images {
      flex-direction: column;
      gap: 24px;

      svg {
        width: 110px;
        height: auto;
      }
    }

    &.landing-therapist-oralo {
      flex-direction: row;
      position: relative;
      width: unset;
      height: unset;
      padding: 61px 24px 61px 258px;
      justify-content: flex-end;
      margin: 48px 0;

      img {
        position: absolute;
        width: 258px;
        height: auto;
        top: 10px;
        left: -40px;
      }

      strong {
        display: inline;
        font-size: 27px;
        line-height: 33px;
      }

      p {
        max-width: 1062px;
        font-size: 27px;
        line-height: 33px;
      }
    }

    &.landing-therapist-settings {
      padding: 24px 24px 24px 258px;
      position: relative;
      align-items: flex-end;
      justify-content: flex-end;

      img {
        position: absolute;
        width: 303px;
        top: -17px;
        left: -36px;
        transform: none;
      }

      h2 {
        max-width: 645px;
      }
    }

    &.landing-therapist-1 {
      max-width: 1584px;
      font-size: 27px;
      line-height: 33px;
    }

    &.landing-therapist-2 {
      max-width: 848px;

      button {
        max-width: unset;
      }
    }

    &.landing-therapist-3 {
      max-width: 707px;
    }

    &.landing-therapist-4 {
      max-width: 571px;
    }

    &.landing-therapist-5 {
      max-width: 718px;
    }

    &.landing-therapist-6 {
      max-width: 801px;
    }
  }
`;
